'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bootstrapInitialWidgetUi = undefined;

var _getMessage = require('conversations-schema/operators/widget-data/getMessage');

var _getPopOpenWidget = require('conversations-schema/operators/message/getPopOpenWidget');

var _getWidgetStartOpen = require('../../widget-ui/selectors/getWidgetStartOpen');

var _isUngatedForNewDisplaySettings = require('../../gates/selectors/isUngatedForNewDisplaySettings');

var _toggleInitialMessageBubble = require('./toggleInitialMessageBubble');

var _getShowInitialMessage = require('../../selectors/getShowInitialMessage');

var _getIsMobile = require('../../selectors/getIsMobile');

var _WidgetActions = require('../../actions/WidgetActions');

var _addClientTriggers = require('../../client-triggers/actions/addClientTriggers');

var _hasClientTriggers = require('../../client-triggers/operators/hasClientTriggers');

var bootstrapInitialWidgetUi = exports.bootstrapInitialWidgetUi = function bootstrapInitialWidgetUi(widgetData) {
  return function (dispatch, getState) {
    var startOpen = (0, _getWidgetStartOpen.getWidgetStartOpen)(getState());
    var welcomeMessage = (0, _getMessage.getMessage)(widgetData);
    var mobile = (0, _getIsMobile.getIsMobile)(getState());
    var popOpenWidget = (0, _getPopOpenWidget.getPopOpenWidget)(welcomeMessage);
    var shouldPopOpenWidget = popOpenWidget && !mobile;
    var showInitialMessage = (0, _getShowInitialMessage.getShowInitialMessage)(getState());
    var shouldSetClientTriggers = showInitialMessage || shouldPopOpenWidget;
    var widgetMustBeOpen = Boolean(startOpen);
    var widgetMustBeClosed = startOpen === false;

    if (widgetMustBeOpen) {
      dispatch((0, _WidgetActions.toggleOpen)(true));
      dispatch((0, _toggleInitialMessageBubble.toggleInitialMessageBubble)(showInitialMessage));
      return;
    }

    if (widgetMustBeClosed) {
      dispatch((0, _WidgetActions.toggleOpen)(false));
      dispatch((0, _toggleInitialMessageBubble.toggleInitialMessageBubble)(showInitialMessage));
      return;
    }

    if (shouldSetClientTriggers && (0, _isUngatedForNewDisplaySettings.isUngatedForNewDisplaySettings)(getState()) && (0, _hasClientTriggers.hasClientTriggers)(widgetData)) {
      dispatch((0, _addClientTriggers.addClientTriggers)(widgetData));
      return;
    }

    if (showInitialMessage) {
      dispatch((0, _toggleInitialMessageBubble.toggleInitialMessageBubble)(true));
    } else {
      dispatch((0, _toggleInitialMessageBubble.toggleInitialMessageBubble)(false));
    }

    if (shouldPopOpenWidget) {
      dispatch((0, _WidgetActions.toggleOpen)(true));
    } else {
      dispatch((0, _WidgetActions.toggleOpen)(false));
    }
  };
};